var _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegralMiddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4WNRdzYTPe1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "46 0 70 66.2",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-166.663-470.591)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0-.1 222.863 470.631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,-229c0,0,0-653,0-653",
    transform: "translate(-54.86 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,-882c0,0,0,653,0,653",
    transform: "translate(-54.86 0.039995)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.76767,22.936h8.54633v65.3h-8.3l.00367-65.3",
    transform: "translate(-0.6 -23)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegralMiddle);
export default __webpack_public_path__ + "static/media/integral_middle.81d9f0f162e8a04eb7085025ba8b33f7.svg";
export { ForwardRef as ReactComponent };